import React from 'react';
import { Divider } from 'antd';

const getName = (events) =>
  `${events.map(({ info }) => `${info.uniqueChar}`).join(', ')}. ${events[0].info.eventName}`;

const EventTableTabs = ({ groupedEvents, onSelect, selectedIndex }) => (
  <div className="event-table-tabs">
    {groupedEvents.map((events, index) => (
      <a
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        className={index === selectedIndex ? 'event-table-tab-active' : 'event-table-tab'}
        onClick={() => onSelect(index)}
        onKeyDown={() => {}}
      >
        {getName(groupedEvents[index])}
      </a>
    ))}
    <Divider style={{ marginTop: '-1px', zIndex: '0' }} />
  </div>
);

export default EventTableTabs;
